<template>
    <div id="fiche-bu-battle-form-block">
        <div class="battle-block" v-for="(battle, i) in battles" :key="battle.id + i">
            <div class="col-12 background-default-light evaluation-title-container">
                <as-title :title="battle['title' + locale]" :size="5" class="color-white p-0"></as-title>
            </div>
            <div class="col-12 background-default-lighter p-0">
                <div v-for="(historyItem) in battle.battleHistoryItem" class="battle-item-block">
                    <div class="p-1 pl-2 pr-2 flex align-items-center">
                        <span class="flex-1">
                            {{ historyItem['label' + locale] }}
                        </span>
                        <div v-if="edit">
                            <Dropdown v-model="historyItem.status" :options="historyItemStatusOptions"
                                optionLabel="label" optionValue="value" style="width: 200px;" />
                        </div>
                        <span v-else
                            :class="'p-1 evaluation-picto color-white ' + this.getEvaluationsCssClass(historyItem.status)"
                            v-tooltip.left="getEvaluationsTooltip(historyItem.status)">
                            <i v-if="pdfBeingGenerated !== true"
                                :class="'pi ' + this.getEvaluationsIcon(historyItem.status)"></i>
                            <img v-else class="p-1" :src="this.getEvaluationsImg(historyItem.status)"></img>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Dropdown from 'primevue/dropdown';
import AsTitle from '../Elements/AsTitle.vue';
import Chip from 'primevue/chip';


export default {
    name: "FicheBuBattleFormBlock",
    components: {
        AsTitle,
        Dropdown,
        Chip
    },
    props: {
        edit: Boolean,
        pdfBeingGenerated: Boolean,
        battles: {
            type: Array,
        }
    },
    computed: {
        locale() {
            const locale = this.$i18n.locale
            const firstLetter = locale.charAt(0).toUpperCase()
            const rest = locale.slice(1).toLowerCase()
            return firstLetter + rest;
        },
    },
    methods: {
        getEvaluationsCssClass(value) {
            switch (value) {
                case 2: return 'background-evaluation-in-progress'
                case 3: return 'background-evaluation-ok'
                default: return 'background-evaluation-not-started'
            }
        },
        getEvaluationsIcon(value) {
            switch (value) {
                case 2: return 'pi-hourglass'
                case 3: return 'pi-check-square'
                default: return 'pi-calendar-times'
            }
        },
        getEvaluationsImg(value) {
            switch (value) {
                case 2: return this.hourglass
                case 3: return this.checkSquare
                default: return this.calendarTimes
            }
        },
        getEvaluationsTooltip(value) {
            switch (value) {
                case 2: return this.$t(`evaluations.IN_PROGRESS`)
                case 3: return this.$t(`evaluations.OK`)
                default: return this.$t(`evaluations.NOT_STARTED`)
            }
        }
    },
    data() {
        return {
            historyItemStatusOptions: [
                { label: this.$t(`evaluations.NOT_STARTED`), value: 1 },
                { label: this.$t(`evaluations.IN_PROGRESS`), value: 2 },
                { label: this.$t(`evaluations.OK`), value: 3 },
            ],
            hourglass: new URL("../../assets/images/fiche-bu/hourglass.png", import.meta.url).href,
            checkSquare: new URL("../../assets/images/fiche-bu/check-square.png", import.meta.url).href,
            calendarTimes: new URL("../../assets/images/fiche-bu/calendar-times.png", import.meta.url).href,
        };
    },
};
</script>

<style lang="scss">
@import "../../assets/styles/colors.scss";

#fiche-bu-battle-form-block {
    display: grid;
    grid-template-columns: repeat(2, minmax(350px, 1fr));
    gap: 20px;
    align-items: start;

    .battle-block {

        &:last-child {
            margin-bottom: 0 !important;
        }

        .battle-item-block:not(:last-child) {
            border-bottom: 1px solid $dark_blue_color;
        }
    }
}

@media (max-width: 1099px) {
    #fiche-bu-battle-form-block {
        grid-template-columns: 1fr !important;
    }
}
</style>
